import { useParams } from "react-router-dom";
import { useFetchOrganizations } from "./useUsersApi";

export const useCurrentUser = () => {
  const { organizationId } = useParams();
  const { isLoading, data: organizationsResponse } = useFetchOrganizations(!!organizationId);
  const organizations = organizationsResponse?.data || [];
  const organization = organizations.find((x: any) => x.organizationId.toLowerCase() === organizationId?.toLowerCase());

  return {
    isLoading,
    organization,
    roles: organization?.availableUserRoles || [],
  };
};
